import { createQueryKeys } from "@lukemorales/query-key-factory";

export const auth = createQueryKeys("auth", {
  account: null,
});
